module.exports = __webpack_public_path__ + "static/media/bg2_md.2ddacd7c.webp";